import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const ConfirmationDialog = ({ open, title, message, onConfirm, onCancel }) => {
    return (
        <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">

            <div className="modal-header" style={{ background: "#1976D2", color: "white", fontWeight: "bold", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px", borderBottom: "1px solid #ddd" }}>
                <DialogTitle>{title || "Confirm Action"}</DialogTitle>
                <IconButton onClick={onCancel} color="dark" data-log="Close Icon Button">
                    <CloseIcon sx={{color:"white"}} />
                </IconButton>
            </div>

            <div className="modal-body" style={{ padding: "16px" }}>
                <DialogContent>
                    <DialogContentText style={{color:"#1C1C1C"}}>{message || "Are you sure you want to proceed?"}</DialogContentText>
                </DialogContent>
            </div>

            <div className="modal-footer" style={{ display: "flex", justifyContent: "flex-end", padding: "16px", borderTop: "1px solid #ddd" }}>
                <DialogActions>
                    <Button onClick={onConfirm} color="primary" variant="contained">
                        Yes
                    </Button>
                    <Button onClick={onCancel} color="error" variant="contained" style={{ marginLeft: "8px" }}>
                        No
                    </Button>
                </DialogActions>
            </div>

        </Dialog>
    );
};

export default ConfirmationDialog;
